export default {
  title: '系统管理',
  icon: 'folder-o',
  children: (pre => [
    { path: `${pre}platform`, title: '应用Key管理' },
    { path: `${pre}proList`, title: '过程管理' },
    { path: `${pre}sysMenu`, title: '菜单管理' },
    { path: `${pre}sysUser`, title: '后台用户管理' }
  ])('/xy/sys-app/')
}
